import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const SkeletonText = () => /*#__PURE__*/_jsx(View, {
  backgroundColor: "fill-accent-neutral-subtle-alt",
  blockSize: "0.8em",
  borderRadius: "full",
  "data-test-id": "skeleton-text",
  display: "inline-block",
  inlineSize: "6em"
});